import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Row, Col, Table } from "react-bootstrap";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";

import api from "../../services/api";

export default function ListaContribuicoes({ history }) {
  const [audiencia, setAudiencia] = useState([]);
  const [resultados, setResultados] = useState([]);
  const [classifica, setClassifica] = useState('DT_SEGUNDOS');
  const [ascendente, setAscendente] = useState(true);

  const { consulta_id } = useParams();
  const [idAudiencia] = useState(consulta_id);

  useEffect(() => {
    async function loadAudiencia() {
      if (!isNaN(idAudiencia)) {
        const response = await api.get(`/api/audiencia/${idAudiencia}`);
        setAudiencia(response.data);
      }
    }
    loadAudiencia();
  }, [idAudiencia]);

  useEffect(() => {
    async function loadResultados() {
      if (!isNaN(idAudiencia)) {
        const response = await api.get(
          `/api/audiencia/${idAudiencia}/rac`
        );
        setResultados(response.data);
      }
    }
    loadResultados();
  }, [idAudiencia]);

  function handleClassificacao(cpo){
    setClassifica(cpo);
    if (ascendente){
      setAscendente(false);
    } else {
      setAscendente(true);
    }
  }
  function formulaClassicacao(a, b) {
    if (ascendente){
      return (a[classifica] < b[classifica] ? -1 : (a[classifica] > b[classifica]? 1 : 0));
    } else {
      return (a[classifica] > b[classifica] ? -1 : (a[classifica] < b[classifica]? 1 : 0));
    }
  }
  return (
    <>
      <Container>
        <Row>
          <Col sm={12}>
            <div className="voltar">
              <a href={`/Consulta/${idAudiencia}`}>voltar</a>
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <h3>
              {audiencia.length > 0 ? audiencia[0].DS_MODALIDADE + " nº ": ""}
              {audiencia.length > 0 ? audiencia[0].NU_AUDIENCIA + "/" + audiencia[0].DT_ANO_AUDIENCIA : ""}
              &nbsp;- RAC – Relatório de Avaliação das Contribuições Recebidas - ({resultados.length} contribuições)
            </h3>
          </Col>
          <Col sm={2} className="linhaBotao">

          </Col>
        </Row>

        <Row>
          <Col sm={12}>
            <Table id="tableContent" striped bordered hover size="sm">
              <thead>
                <tr className="tituloContribuicao">
                  <th width="15%">
                    <span
                      className="Aponta"
                      data-toggle="tooltip"
                      title="Clique aqui para classificar"  
                      onClick={() => handleClassificacao("DT_SEGUNDOS")}
                    >
                      Data &nbsp;&nbsp;
                      {classifica === "DT_SEGUNDOS" ? ascendente ? <FaChevronUp /> : <FaChevronDown /> : ""}
                    </span> 
                  </th>
                  <th width="20%">
                    <span
                      className="Aponta"
                      data-toggle="tooltip"
                      title="Clique aqui para classificar"  
                      onClick={() => handleClassificacao("NO_INSTITUICAO")}
                    >
                      Instituição &nbsp;&nbsp;
                      {classifica === "NO_INSTITUICAO" ? ascendente ? <FaChevronUp /> : <FaChevronDown /> : ""}
                    </span> 
                  </th>
                  <th width="20%">
                    <span
                      className="Aponta"
                      data-toggle="tooltip"
                      title="Clique aqui para classificar"  
                      onClick={() => handleClassificacao("DS_APROVEITAMENTO")}
                    >
                      Aproveitamento &nbsp;&nbsp;
                      {classifica === "DS_APROVEITAMENTO" ? ascendente ? <FaChevronUp /> : <FaChevronDown /> : ""}
                    </span> 
                  </th>
                  <th width="45%">
                    <span
                      className="Aponta"
                      data-toggle="tooltip"
                      title="Clique aqui para classificar"  
                      onClick={() => handleClassificacao("DS_JUSTIFICATIVA")}
                    >
                      Justificativa &nbsp;&nbsp;
                      {classifica === "DS_JUSTIFICATIVA" ? ascendente ? <FaChevronUp /> : <FaChevronDown /> : ""}
                    </span> 
                  </th>
                </tr>
              </thead>
              <tbody>
                {resultados.sort((a, b) => formulaClassicacao(a,b))
                    .map((res, index) => ( 
                  <tr key={res.ID_CONTRIBUICAO}>
                    <td>
                      {res.DT_DATA}
                    </td>
                    <td>
                      {res.NO_INSTITUICAO}
                    </td>
                    <td>
                      {res.DS_APROVEITAMENTO}
                    </td>
                    <td> 
                      {res.DS_JUSTIFICATIVA}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Container>
    </>
  );
}
